var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","x-small":"","depressed":"","loading":_vm.loading},on:{"click":_vm.open}},[_vm._v("Import")])
}
var staticRenderFns = []

export { render, staticRenderFns }